<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar>
      <span class="topT">银联支付</span>
      <!--返回上一层-->
      <mu-icon value="keyboard_arrow_left" color="white" style="margin-bottom: -0.05rem" slot="left" v-on:click="goback" />
      <mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />
    </mu-appbar>
  
    <div style="width:100% ; margin-top:0.3rem" align="center">

      <div style="width:92% ; text-align:left ;  margin:0.2rem 0 0.2rem 0">
          <span style=" color:#666666 ;font-size:0.3rem ; ">金额</span>
          <span style="margin-left:0.6rem ;  font-weight:bold ;color:#333333 ;font-size:0.3rem ; " >
          ￥ {{this.g_PayOrder.Money  }}
        </span>
      </div>
      <mu-divider style="width:92%" />


      <div style="width:92% ; text-align:left ;  margin:0.2rem 0 0.2rem 0">
          <span style=" color:#666666 ;font-size:0.3rem ; ">卡号</span>
          <span style="margin-left:0.6rem ;    ;color:#333333 ;font-size:0.3rem ; " >
            <input v-model="CardNum"   style="    border:0 ; outline:0 ;   font-size:0.3rem ; width: 5.3rem" placeholder="请输入银行卡号" />
          </span>
      </div>
      <mu-divider style="width:92%" />



      <mu-raised-button label="下一步" primary=""   v-bind:style="{ width:'92%', height:'0.9rem' }" style="font-size: 0.3rem ; margin-top:0.3rem ; " 
      v-on:click="ValidateBankCard"  />
      
      <mu-divider style="margin-top:0.7rem  ;   margin-bottom:0.2rem ; width:92%" />

      <table style="width:92% ; font-size:0.24rem ; color:#666666 "  border ="0">
        <tr>
          <td style="width:0.3rem">
            ·
          </td>
          <td>
            格林豪泰酒店不会记录您任何银行卡信息，
          </td>
          <td rowspan="3">
            <img src="../../../../static/order/YinLian-Big.png" style=" width:1.5rem " />

          </td>
        </tr>


        <tr>
          <td>          </td>
          <td>
            所有信息均由加密通道传递给中国银联
            <br />
            <br />

          </td>
        </tr>


        <tr>
          <td>
            ·
          </td>
          <td>
            本服务由银联在线提供技术支持
          </td>
        </tr>
      </table>

      <mu-divider  style="margin-top:0.2rem  ;; width:92%"/>

    </div>
  



 

<!--弹出框-->
<mu-toast v-if="toast" :message="TellUser" @close="hideToast" id="alertline" />


  </div>
</template>








<script>


import { mapMutations, mapGetters } from 'vuex'
import api from '../../../api'



export default {
  computed: {
    ...mapGetters([
      'g_UserInfo','g_PayOrder'
    ])
  },
  activated() {

    this.CardNum = '';
    this.init();
  },
  data() {
    return {
      // CardNum:' 6226 0900 0000 0048  ',
      CardNum:'',

      // 弹出层
      TellUser:'',
      toast: false,
      // 弹出标签 选择是否
      dialog: false

    }
  },
  methods: {
    ...mapMutations([
      'setG_PayOrder',
    ]),


    init(){
      // 没有初始化方法
    },

    // 验证银行卡号是否正确  正确就下一步
    ValidateBankCard(){

      this.CardNum = this.CardNum.trim();

      if(this.CardNum.length < 11 ){
        this.TellUser = "请输入正确的银行卡号"
        this.showToast();
        return
      }
      
      for( let i=0 ; i<10 ; i++)
        this.CardNum = this.CardNum.replace(" ", "");
      
      var params = new this.URLSearchParam();
      params.append('bankCard', this.CardNum);
      this.$http.post(api.ValidateBankCard(   this.g_PayOrder.PayFor   ), params.toParam()).then((res) => {

        console.log(res)   

        if (res.Result) {

          var Order = this.g_PayOrder;

          // 这里有大小写
          Order.CardType = res.Data.cardType;
          Order.CardNo = this.CardNum;
          Order.CardReplace = this.CardNum;

          this.setG_PayOrder( Order );

          // alert(  this.g_PayOrder.CardNo )

          if( this.g_PayOrder.CardType == '信用卡')
            this.$router.push({ path: '/order/PayByUnion/NextCredit' });

          else if( this.g_PayOrder.CardType == '借记卡')
            this.$router.push({ path: '/order/PayByUnion/NextDebit' });

          else
            alert("err:" + this.g_PayOrder.CardType)
            
        }
        else {
          //调用弹出层
          this.TellUser = res.Message;
          this.showToast();
        }

      })
    },


// 华夏银行贷记卡：   6226388000000095
// cvn2：  248
// 手机号：  18100000000
// 有效期：   19   12                     1219    （后台接口注意格式YYMM需倒一下）
// 短信验证码：  123456  （手机）/111111（PC）（先点获取验证码之后再输入）
// 证件类型： 01
// 证件号： 510265790128303
// 姓名： 张三

// 招商借记卡账号：  6226 0900 0000 0048  
// 手机号：    18100000000
// 密码：   111101
// 短信验证码：   123456   （手机）/    111111(PC)（点击获取验证码后输入）
// 证件类型：01
// 证件号:510265790128303
// 姓名：张三


    goback() {
      javascript: history.go(-1);
    },

    // 弹出层
    showToast() {
      this.hideToast();
      this.toast = true;
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
      if (this.TellUser =='未登录'){
        this.$http.post(api.LogOff()).then((res) => {           });
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1200)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end

  },
  // watch: {
  //   $route(to, from) {
  //     if (to.path == "/order/PayByUnion/BeforeBind") {
  //       this.init();
  //     }
  //   },
  // },




}
</script>




// paper模块
<style lang="less" scoped>
@import "../../../assets/theme.less";
.demo-paper {
  // 横向显示
  /*display: inline-block;*/
  margin: 8px;
  text-align: center;
  margin-top: 10px;
}

.green {
  color: @primaryColor ;
  border: 1px solid @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;

  color: @textColor; // 顶部标签变换
  .header {
    width: 100%
  }
  .mu-tabs {
    // 背景色
    background-color: #fff;
  } // 未选中时候的颜色
  .mu-tab-link {
    color: #999999;
    font-weight: bold;
  } //  选中  分页的
  .mu-tab-active {
    color: @primaryColor;
    font-weight: bold;
  } // END 顶部标签变换
  .Orange {
    color: @primaryOrange ;
  }
  .Black {
    color: @primaryBlack ;
  }
  .Grey {
    color: @textColor;
  }
}
</style>





// WEBPACK FOOTER //
// BeforeBind.vue?f31a3e94